import React, { useContext } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import './App.css';
import Routes from './routes';
import { AuthenticationContext } from './contexts/Authentication';
import EmailModal from './components/EmailModal';
import { I18nextProvider } from 'react-i18next';
import i18n from './locale/i18n';

function App() {
  const { state: { authenticated, userData } } = useContext(AuthenticationContext);
  return (
    <>
      <I18nextProvider i18n={i18n}>
        <Router>
          <Routes />
        </Router>
      </I18nextProvider>
      {authenticated && !userData?.emailVerified && <EmailModal userEmail={userData?.email || ''} />}
    </>
  );
}

export default App;
